import React from "react";

function About() {
  return (
    <div id="content" class="site-content">
      <div id="primary" class="content-area">
        <main id="main" class="site-main studio" role="main">
          <article
            id="post-6"
            class="post-6 page type-page status-publish hentry"
          >
            <header class="entry-header">
              <h1 class="entry-title">(Fr) Studio</h1>{" "}
            </header>

            <div class="entry-content-about">
              <div id="presentation" class="calage"></div>
              <div class="intro">
                <p class="p1">
                Estudio DE arquitectura es formado en el año 2000 en la ciudad de La Plata, Provincia de Buenos Aires, por Juliana Deschamps y Fabio Estremera; ambos graduados en la Facultad de Arquitectura y Urbanismo de la Universidad Nacional de La Plata. La oficina desarrolla la práctica del oficio imbricado con la actividad docente y la producción de concursos. Ésta interacción confluye en la sinergia necesaria para una práctica reflexiva y en permanente revisión, lo que lleva a una producción diversa en cuanto a temáticas, escalas y contextos; y colaborativa con otros estudios y oficios.
                  <br />
                  &nbsp;
                  <br />
                  La oficina coloca al proyecto como la instancia previa que da paso a la arquitectura,  por ello instala como categorías los aspectos concretos e inmanentes del tema-programa, el usuario y el lugar. Desde allí discurre el proceso proyectual entendido como una reflexión teórica de base crítica donde la expresión final concluye cuando la interacción espacio – construcción – forma encuentra su síntesis y elocuencia visual. Se abre paso a una arquitectura cuyo discurso es la potencialidad de ser habitada y resignificada por el usuario en el tiempo.
                </p>
              </div>
              <div class="titres-studio">
                <p class="p1">Estudio</p>
              </div>
              <div class="main-text-about">
                <p class="autor-content">
                  <strong>Juliana Deschamps.</strong>
                </p>
                <p class="p1">
                La Plata, 1975. Graduada de la Facultad de Arquitectura de la Universidad Nacional de La Plata (FAU-UNLP) Distinguida con el Joaquín V. González a los mejores promedios de la UNLP. Es Ayudante de Curso en la materia Arquitectura, Jefa de Trabajos Prácticos de Introducción a la materialidad ambas FAU – UNLP. Cursa la carrera de Especialización en Docencia Universitaria de la Universidad Nacional de La Plata. Integró el cuerpo de Jurados y Asesores del Colegio de Arquitectos de la Provincia de Buenos Aires por el período 2013 – 2016, integrando equipos de jurados en diversos concursos distritales y provinciales. Ha participado en calidad de ponente en numerosas conferencias, debates y exposiciones.
                </p>
                <p class="autor-content">
                  <strong>Fabio Estremera.</strong>
                </p>
                <p class="p1">
                Bahía Blanca, 1971. Graduado de la Facultad de Arquitectura de la Universidad Nacional de La Plata (FAU-UNLP) Distinguido con el Joaquín V. González a los mejores promedios de la UNLP. Es Jefe de Trabajos Prácticos en la materia Arquitectura, Co-titular de la A.E.O. Técnicas de Actualización Proyectual, y A.C.D.O. en Historia de la Arquitectura todas en la FAU – UNLP. Es Profesor Titular del Taller de Proyecto Urbano de la Carrera Arquitectura en la Universidad Nacional de Avellaneda. Es Maestrando en la Maestría de Proyecto Arquitectónico y Urbano de la Facultad de Arquitectura y Urbanismo de la Universidad Nacional de La Plata. Integra el cuerpo de Jurados y Asesores del Colegio de Arquitectos de la Provincia de Buenos Aires desde el año 2013 a la fecha, ha integrado cuerpos de asesores y jurados en diversos concursos distritales, provinciales, nacionales e internacionales. Ha participado en calidad de ponente en numerosas conferencias, debates y exposiciones.
                </p>
              </div>
              
              <div id="prix" class="calage"></div>
              <div class="titres-studio">
                <p class="p1">Premios y distinciones</p>
              </div>
              <div class="main-text-about">
              <em>2021 -</em> Mención Honrosa. Concurso Internacional Espacio Cívico y Ciudadano en la ex Cárcel de Talca. Talca, Maule, Chile.
                <br />
                <em>2020 -</em> Tercer Premio. Premio Provincial “Obra Construida” por la casa EB, Colegio de Arquitectos de la Provincia de Buenos Aires. 
                <br />
                <em>2020 -</em> Segundo Premio. Concurso a dos vueltas para la Residencia de adultos mayores en Hospitalet de l’infant, Cataluña, España. Asociado al estudio Sulkin Marchissio SCA (BCN). 
                <br />
                <em>2020 -</em> Segundo Premio. Concurso Nacional de Anteproyectos paras el Parque de la Ciudad y escuela de música popular de Comodoro Rivadavia, Provincia de Chubut, Argentina. 
                <br />
                <em>2020 -</em> Mención Especial. Concurso Nacional de Anteproyectos para el Complejo Educativo tres facultades y campus universitario. Tigre, Provincia de Buenos Aires, Argentina. 
                <br />
              <em>2019 -</em> Primer Premio. Premio Provincial “Obra Construída” por el Archivo General de la Nación, Colegio de Arquitectos de la Provincia de Buenos Aires. 
                <br />
                <em>2018 -</em> Segundo Premio. Concurso a dos vueltas para el Archivo Nacional de Cataluña. San Cugat del Vallés, Cataluña, España. Asociado al estudio Sulkin Marchissio SCA. 
                <br />
                <em>2017 -</em> Segundo Premio. Concurso para el Centro Socio Cultural San Martí, Barcelona, Cataluña, España. Asociado al estudio Sulkin Marchissio SCA. 
                <br />
                <em>2015 -</em> Mención de Honor. Concurso Provincial para el Anexo del Ministerio de Economía de la Provincia de Buenos Aires, La Plata, Provincia de Buenos Aires, Argentina.
                <br />
                <em>2014 -</em> Estudio Integrante. Muestra Nacional Itinerante “El material de lo construido – 25 estudios de la República Argentina”. Curada y Organizada por Bisman Ediciones y auspiciada por Weber Saint Gobain.
                <br />
                <em>2012 -</em> Primer Premio. Concurso Nacional para el Archivo General de la Nación, Ciudad Autónoma de Buenos Aires, Argentina. 
                <br />
                <em>2012 -</em> Mención de Honor. Concurso Nacional para la Escollera Norte del Puerto de Mar del Plata, Provincia de Buenos Aires, Argentina.
                <br />
                <em>2010 -</em> Primer Premio. Concurso Distrital para la Sede del Colegio de Arquitectos Distrito1, La Plata, Provincia de Buenos Aires, Argentina.
                <br />
                <em>2009 -</em> Primer Premio. Concurso Distrital para el Sitio Conmemorativo del Bicentenario. La Plata, Provincia de Buenos Aires, Argentina.
                <br />
                <em>2008 -</em> Obra seleccionada. Bienal SCA-CPAU por la obra “Tres viviendas agrupadas”. Ciudad Autónoma de Buenos Aires, Argentina.
                <br />
                <em>2008 -</em> Primer Premio. Premio Provincial “Obra Construida” por el Archivo General de la Nación, Colegio de Arquitectos de la Provincia de Buenos Aires.
                <br />
                <em>2005 -</em> Segundo Premio. Concurso Provincial para el Reordenamiento Paisajístico e infraestructura turística del Cerro La Movediza, Tandil, Provincia de Buenos Aires.
                <br />
                <em>2003 -</em> Mención de Honor. Concurso Nacional para la Sede Municipalidad de Dolavon, Provincia de Chubut, Argentina.
                <br />
                <em>2002 -</em> Segundo Premio. Concurso Nacional Fundación Arquitectónica de Rosario para Arquitectos Jóvenes. Rosario, Provincia de Santa Fé, Argentina.
                <br />
                <em>2000 -</em> Quinto Premio. Concurso Bienal Internacional de Arquitectura de Sao Paulo, Sao  Paulo, Brasil.
              </div>

              <div id="contact" class="calage"></div>
              <div class="titres-studio">
                <p class="p1">Contacto</p>
              </div>
              <div class="main-text-about">
                <strong>Dirección</strong>
                <p>Calle 54 N1536 - La Plata – Provincia de Buenos Aires - Argentina</p>
                <strong>Teléfonos</strong>
                <p>+54 9 221 5580753</p>
                <p>+54 9 221 5580754</p>

                <p>
                  <strong> Email </strong>
                </p>
                <p>
                  <a href="mailto:contacto@deschampsestremeramasarq.com.ar">contacto@deschampsestremeramasarq.com.ar</a>
                </p>
                <p>
                  <strong> Instagram </strong>
                </p>
                <p>
                  <a href="https://www.instagram.com/deschampsestremeramasarq/"target="_blank">@deschampsestremeramasarq</a>
                </p>
              </div>








              
            </div>
          </article>
        </main>
      </div>
    </div>
  );
}

export default About;
